<template>
  <div class="navbar-logo-container">
    <div class="navbar-logo-link">
      <div class="itms-logo-bg-out">
        <div class="itms-logo-bg" />
        <div class="gray-line" />
        <div translate="no" class="itms-system-name">iTMS</div>
      </div>
      <!-- 图片logo  样式一-->
      <!-- <span v-if="isEnglish === 'en_US'" class="logo-img"><img src="@/assets/img/system/itms_logo_newEn.png" style="height:56px;margin-right:24px;"></span>
      <span v-else class="logo-img"><img src="@/assets/img/system/itms_logo_newCn.png" style="height:56px;margin-right:24px;"></span> -->
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'NavbarLogo',
  data() {
    return {
      title: '京东物流系统名称'
    }
  },
  computed: {
    isEnglish() {
      return Cookies.get('language') || 'zh_CN'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/styles/mixins.scss";
  @font-face {
    font-family: JINGDONGLangZhengTi1;
    src: url("~@/assets/styles/fonts/JDZhengHT-Regular.ttf") format("truetype"); /* chrome, firefox, opera, Safari, Android, iOS 4.2+ */
    font-style: normal;
    font-weight: normal;
  }
  .navbar-logo-container {
    float: left;
    height: 100%;
    line-height: $navHeight;
    margin: 0;

    .navbar-logo-link {
      display: block;
      height: 44px;
      .itms-logo-bg-out{
        width: 233px;
        height: 38px;
        margin-top: 20px;
        position: relative;
        .itms-logo-bg{
          position: absolute;
          width: 128px;
          height: 33px;
          left: 24px;
          top: 5px;
          background-image: url('~@/assets/img/header/jdl-logo.png');
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
        .gray-line{
          width: 1px;
          height: 16px;
          position: absolute;
          left: 160px;
          top: 4px;
          background-color: rgba(36,37,43,0.1);
          z-index: 1;
        }
        .itms-system-name{
          position: absolute;
          left: 160px;
          top: 1px;
          height: 22px;
          font-size: 22px;
          font-family: JINGDONGLangZhengTi1;
          color: rgba(35,37,43,1);
          line-height: 22px;
          padding-left: 8px;
        }
      }
    }

    .sidebar-logo {
      max-height: $logoHeight;
      vertical-align: middle;
    }

    .dep {
      display: inline-block;
      width: 1px;
      height: 20px;
      line-height: 20px;
      opacity: .6;
      @include themify() {
        background: themed('primary-color');
      }
      margin: 0 10px;
      vertical-align: middle;
    }

    .sidebar-title {
      display: inline-block;
      color: #fff;
      font-weight: 600;
      font-size: 22px;
      vertical-align: middle;
    }
  }
</style>
